<div class="common-text-input__container"
  [id]="field.id">
  <div class="common-field-with-button__container-box"
    [ngClass]="{'common-field-with-button__container-box--error': field.error}"
    [attr.disabled]="field.noEditable?true:null">
    <div class="common-field-with-button__block-header">
      <div class="common-text-input__label-no-cursor">
        <span class="common-text-input__text-label">{{field.label}}</span>
        @if (field.required) {
          <span class="common-tag__mandatory-text-asterisk">*</span>
        }
        <div class="common-text-input__block-buttons">
          @if (field.references?.length) {
            <tooltip-law [references]="field.references"
            [field]="field"></tooltip-law>
          }
      </div>
    </div>
    @if (field.description) {
      <div class="common-field-with-button__text-description"
      [innerHTML]="field.description"></div>
    }
  </div>
  <div class="common-field-with-button__buttons-container">
    <button class="common-button__text-little-border"
      [disabled]="field.noEditable"
      (click)="generateReportPdf()">
      <i class="lf-icon-search-rrhh common-icon__sm"></i>
      <span class="common-button__text-little-title"
      [afTranslate]="'field-type-consult-lists.consult-list'">_Consultar listas</span>
    </button>
  </div>
  @if (field.evaluatedValue.documents?.length) {
    <div class="common-field-with-button__items-block"
      >
      @for (document of field.evaluatedValue.documents | afOrderBy:'documentObjectId':true | afLimitTo:1; track $index) {
        <div class="common-field-with-button__item-container"
          >
          <div class="common-field-with-button__text-container">
            <i [class]="'lf-icon-step-final common-field-with-button__icon-step-'+ document.color"></i>
            <div class="common-field-with-button__info-line-container">
              <span class="common-field-with-button__label-text">
                <span [afTranslate]="'field-type-consult-lists.report'">_Informe</span>:
              </span>
              <button class="common-button__link"
                [disabled]="field.noEditable"
                (click)="downloadDocument(document)">
                <span class="common-button__link-text">{{document.name}}</span>
              </button>
            </div>
          </div>
          @if (!field.noEditable) {
            <button class="common-field-with-button__button-action"
              pTooltip="{{'common.remove' | afTranslate}}"
              tooltipPosition="top"
              (click)="removeDocument(document)">
              <i class="lf-icon-trash common-icon__md"></i>
            </button>
          }
        </div>
      }
    </div>
  }
</div>
<div class="common-text-input__mandatory-tag"
  [ngShow]="field.error">
  <i class="lf-icon-warning common-icon__error-md"
  [ngShow]="field.blocker"></i>
  <span [afTranslate]="field.blocker?'common.field-mandatory-blocking':'common.field-mandatory'">Campo obligatorio</span>
</div>
</div>
